import React from "react";
import { useI18n } from "@nelurio/i18n";

const PRESETS: Array<{ hex: string; key: string }> = [
  { hex: "#6c4cf6", key: "color.purple" },
  { hex: "#4d8df7", key: "color.blue" },
  { hex: "#4dbd74", key: "color.green" },
  { hex: "#f4b942", key: "color.amber" },
  { hex: "#ff6863", key: "color.red" },
  { hex: "#34c3b9", key: "color.teal" },
  { hex: "#e0679c", key: "color.pink" },
  { hex: "#17182b", key: "color.ink" }
];

/** Course color palette: preset swatches + a custom color input. The picked
 *  color flows into the course card AND every chart that uses course colors.
 *  Swatches carry localized NAMES (never raw hex) per the a11y law. */
export function ColorPicker({ value, onChange }: { value: string; onChange: (color: string) => void }) {
  const { t } = useI18n();
  const active = value.toLowerCase();
  return (
    <div className="color-picker" role="group" aria-label={t("color.pickerLabel")}>
      {PRESETS.map((preset) => (
        <button
          key={preset.hex}
          type="button"
          className={`color-picker__swatch ${active === preset.hex ? "is-active" : ""}`}
          style={{ background: preset.hex }}
          onClick={() => onChange(preset.hex)}
          aria-label={t(preset.key)}
          aria-pressed={active === preset.hex}
          title={t(preset.key)}
        />
      ))}
      <label className="color-picker__custom" title={t("color.custom")}>
        <input type="color" value={/^#[0-9a-fA-F]{6}$/.test(value) ? value : "#6c4cf6"} onChange={(event) => onChange(event.target.value)} aria-label={t("color.custom")} />
        <span>+</span>
      </label>
    </div>
  );
}
